import type { ConflictIntent } from "./types.js";

type TextReader = (value: unknown, label: string) => string;
type FieldChecker = (
  value: Record<string, unknown>,
  fields: readonly string[],
  label: string,
) => void;

export function isDiplomacyKind(kind: string): boolean {
  return ["propose-pact", "accept-pact", "end-pact", "send-metal"].includes(kind);
}

export function decodeDiplomacyIntent(
  kind: string,
  source: Record<string, unknown>,
  readText: TextReader,
  exact: FieldChecker,
): ConflictIntent {
  if (kind === "propose-pact") {
    const keys = Object.keys(source);
    if (
      !keys.includes("kind") ||
      !keys.includes("targetSeatId") ||
      keys.some((key) => !["kind", "targetSeatId", "message"].includes(key))
    )
      throw new TypeError("Pact proposal intent has unknown or missing fields");
    return Object.freeze({
      kind,
      targetSeatId: readText(source.targetSeatId, "targetSeatId"),
      ...(source.message === undefined ? {} : { message: readText(source.message, "message") }),
    }) as ConflictIntent;
  }
  if (kind === "accept-pact") {
    exact(source, ["kind", "targetSeatId"], "Pact acceptance intent");
    return Object.freeze({ kind, targetSeatId: readText(source.targetSeatId, "targetSeatId") });
  }
  if (kind === "end-pact") {
    exact(source, ["kind", "targetSeatId", "confirmed"], "Pact termination intent");
    if (source.confirmed !== true) throw new TypeError("Pact termination must be confirmed");
    return Object.freeze({
      kind,
      targetSeatId: readText(source.targetSeatId, "targetSeatId"),
      confirmed: true,
    });
  }
  exact(source, ["kind", "targetSeatId", "amount", "confirmed"], "Shipment intent");
  if (source.confirmed !== true) throw new TypeError("Shipment must be confirmed");
  return Object.freeze({
    kind: "send-metal",
    targetSeatId: readText(source.targetSeatId, "targetSeatId"),
    amount: readText(source.amount, "amount"),
    confirmed: true,
  });
}
